export const VOUCHER_QR_CODE_INPUT_ID = 'voucher-qr-code-input'
